export default __webpack_public_path__ + "static/media/permissions-selected.64657736.svg";